import { useQuery } from '@tanstack/react-query';
import { reservationOptions } from '../../constants/reservations';
export function useReservations(filter, scope, options) {
    const { data, isLoading, isSuccess } = useQuery(reservationOptions.get(filter, scope, { enabled: options?.enabled }));
    return {
        reservations: data ?? [],
        loadingReservations: isLoading,
        isSuccess,
    };
}
